import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

const ClientLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
            navigate('/profile');
  };

  const getPageTitle = () => {
    if (location.pathname.includes('/orders')) {
      return 'Historial de Pedidos';
    }
    return 'Restaurantes visitados';
  };

  return (
    <div className="min-h-screen min-h-[100dvh] bg-[#e9ecef] flex flex-col">
      {/* Header */}
      <div className="bg-[#22B6B2] shadow-sm sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center space-x-3">
            {/* Botón de regreso */}
            <button
              onClick={handleBack}
              className="p-2 text-white hover:text-white/80 hover:bg-white/10 rounded-lg transition-colors"
            >
              ←
            </button>
            
            {/* Título a la izquierda */}
            <h1 className="text-md font-bold text-white">
              {getPageTitle()}
            </h1>
          </div>
        </div>
      </div>

      {/* Contenido principal */}
      <div className="flex-1 min-h-0 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default ClientLayout; 